/**
 * Curated cover messages — Document 6 §12.2, Constitution v1.2 §8 exception 1.
 *
 * The instructor SELECTS one of these or none. The instructor cannot author or
 * edit this text, which is what keeps a client-facing document free of medical
 * claims and free of promises about future results.
 *
 * These sentences deliberately contain no numeric claim, no dietary or
 * therapeutic statement, no comment on the student's body, and no studio or
 * product name — so one set serves every studio.
 *
 * The snapshot freezes both the key AND the resolved text (Doc 6 §16.1 rule 3).
 * Revising a sentence here must never rewrite a report already sent to a
 * student.
 */

export interface CoverMessage {
  key: string;
  text: string;
}

export const COVER_MESSAGES: readonly CoverMessage[] = [
  {
    key: 'cover_msg_01',
    text: 'Düzenli çalışmanın ve sabrın sonuçlarını birlikte görüyoruz. Bu yolda ilerlemeye devam.',
  },
  {
    key: 'cover_msg_02',
    text: 'Her ders, bedeninize verdiğiniz değerin bir göstergesi. Emeğiniz için tebrikler.',
  },
  {
    key: 'cover_msg_03',
    text: 'İstikrar en büyük gücünüz. Bu dönemdeki emeğiniz raporunuza yansıyor.',
  },
  {
    key: 'cover_msg_04',
    text: 'Gelişim bir yarış değil, bir yolculuk. Kendi ritminizde ilerliyorsunuz.',
  },
  {
    key: 'cover_msg_05',
    text: 'Bedeninizi tanımak zaman ister. Bu süreçte attığınız adımlar değerli.',
  },
  {
    key: 'cover_msg_06',
    text: 'Küçük ve düzenli adımlar, kalıcı değişimin temelidir.',
  },
  {
    key: 'cover_msg_07',
    text: 'Bu dönemde gösterdiğiniz katılım ve disiplin için teşekkür ederiz.',
  },
  {
    key: 'cover_msg_08',
    text: 'Güç, esneklik ve denge birlikte gelişir. Siz de bu dengeyi kuruyorsunuz.',
  },
  {
    key: 'cover_msg_09',
    text: 'Kendinize ayırdığınız her dakika, uzun vadeli sağlığınıza yapılan bir yatırım.',
  },
  {
    key: 'cover_msg_10',
    text: 'Yolculuğunuzun bir sonraki adımında da yanınızdayız.',
  },
];

const BY_KEY = new Map(COVER_MESSAGES.map((m) => [m.key, m]));

export function findCoverMessage(key: string | null | undefined): CoverMessage | null {
  if (!key) return null;
  return BY_KEY.get(key) ?? null;
}

/** Doc 6 §18.5 — the note is capped, trimmed, and snapshot-only. */
export const REGIONAL_NOTE_MAX_LENGTH = 300;

export const POSTURE_NOTE_MAX_LENGTH = 300;

/**
 * A cover message the instructor writes themselves — Constitution v1.3 §8,
 * exception 3.
 *
 * The curated list stays, and stays first: it exists so a studio never has to
 * think about what is safe to print above a student's name. But a fixed list
 * of ten sentences across every report a studio ever sends reads as a form
 * letter, which is the opposite of what the report is for.
 *
 * Shorter than the regional note on purpose. This sits under the student's
 * name on the cover at 15px italic; past roughly two lines it stops being a
 * greeting and starts being a paragraph the cover has no room for.
 */
export const COVER_MESSAGE_MAX_LENGTH = 200;

/** The key a snapshot carries when the instructor wrote the sentence. */
export const CUSTOM_COVER_MESSAGE_KEY = 'custom';
